import request from '@/utils/request';
//会员列表
export function getMemberList(param) {
  return request('/member/queryMemberPage', {
    method: 'POST',
    data: param,
  });
}
//总数据条数
export function getTotalData() {
  return request('/member/queryMemberCount', {
    method: 'GET',
    // data: param,
  });
}
//获取等级列表
export function getLevels() {
  return request('/config/queryLevels', {
    method: 'GET',
  });
}
//门店列表
export function getStoreList(values) {
  return request('/store/queryPage', {
    method: 'POST',
    data: values,
  });
}

//新增会员列表
export function addMember(values) {
  return request('/membership/members', {
    method: 'POST',
    data: values,
  });
}
